<template>
  <div class="table-wrapper">
    <!-- نمایش جدول در دسکتاپ -->
    <div class="desktop-table" v-show="!isMobile">
      <el-table
        :data="props.data"
        border
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f5f7fa', fontWeight: 'bold' }"
        :cell-style="{ fontSize: '14px' }"
        :scrollbar-always-on="true"
      >
        <el-table-column prop="dayName" label="روز هفته" min-width="100" />
        <el-table-column prop="date" label="تاریخ" min-width="100" />
        <el-table-column prop="onHours" label="ساعت کارکرد" min-width="100" />
        <el-table-column prop="capacity" label="حجم آب (مترمکعب)"  min-width="120" />
        <!--<el-table-column
        label="عملیات"
        fixed="right"
        width="120"
        align="center"
      >
        <template #default="scope">
          <el-button size="small" type="primary" @click="exportSingleRow(scope.row)">خروجی</el-button>
        </template>
      </el-table-column>-->
      </el-table>
    </div>

    <!-- موبایل: ظاهر مشابه عکس -->
    <div class="mobile-cards" v-show="isMobile">
      <div
        v-for="(item, index) in props.data"
        :key="index"
        class="mobile-row-like-table"
      >
        <!-- ردیف اول -->
        <div class="row">
          <div class="cell">
            <strong>{{ item.dayName }}</strong>
          </div>
          <div class="cell">{{ item.date }}</div>
        </div>

        <!-- ردیف دوم -->
        <div class="row">
          <div class="cell">ساعت کارکرد</div>
          <div class="cell">{{ item.onHours }} ساعت</div>
        </div>

        <!-- ردیف سوم -->
        <div class="row">
          <div class="cell">مصرف</div>
          <div class="cell">{{ item.capacity }} مترمکعب</div>
        </div>
      </div>
    </div>
    <!-- دکمه‌ها -->
    <el-button class="btn-export-table" @click="exportExcel"
      >خروجی اکسل</el-button
    >
    <el-button type="primary" class="btn-export-table" @click="exportImage"
      >خروجی تصویر</el-button
    >
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps } from "vue";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";

const isMobile = ref(window.innerWidth < 768);

function handleResize() {
  isMobile.value = window.innerWidth < 768;
}

onMounted(() => {
  window.addEventListener("resize", handleResize);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const props = defineProps({ data: { type: Array, default: () => [] } });

/*function handlePageChange(page) {
  currentPage.value = page;
}*/

function exportExcel() {
  const data = props.data;

  // تعریف عنوان ستون‌ها به فارسی و ترتیب دلخواه (مثلاً 'روز هفته' آخر)
  const headers = ["capacity", "onHours", "date", "dayName"]; // ترتیب ستون‌ها
  const headerLabels = {
    dayName: "روز هفته",
    onHours: "ساعت کارکرد",
    date: "تاریخ",
    capacity: "آب مصرفی / مترمکعب", // اگر بخوای حذفش کنی کافیه تو اینجا نباشه
  };

  // ساخت آرایه AOA با عنوان‌ها
  const rows = [];

  // ردیف عنوان ستون‌ها
  rows.push(headers.map((h) => headerLabels[h]));

  // ردیف داده‌ها
  data.forEach((item) => {
    const row = headers.map((h) => item[h]);
    rows.push(row);
  });

  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, "report.xlsx");
}

function exportImage() {
  const tableElement = isMobile.value
    ? document.querySelector(".mobile-cards")
    : document.querySelector(".el-table");

  if (!tableElement) return;

  html2canvas(tableElement, {
    scale: 2, // کیفیت بیشتر
    useCORS: true,
  }).then((canvas) => {
    const link = document.createElement("a");
    link.download = "table.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  });
}
</script>

<style scoped>
.table-wrapper {
  overflow-x: auto;
  direction: rtl;
  text-align: center;
  margin-top: 10px;
}
::v-deep(.el-table .cell) {
  text-align: center !important;
}
.btn-export-table {
  margin: 10px;
}

.desktop-table {
  overflow-x: auto;
}
.mobile-row-like-table {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 8px 12px;
  background: #fff;
  margin-bottom: 12px;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.mobile-row-like-table .row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-row-like-table .row:last-child {
  border-bottom: none;
}

.mobile-row-like-table .cell {
  width: 48%;
  text-align: right;
}
</style>
